export const ApplyParamsRecordEffectSpecID = "gadget/effect/applyParams";
export const CreateRecordEffectSpecID = "gadget/effect/createRecord";
export const UpdateRecordEffectSpecID = "gadget/effect/updateRecord";
export const DeleteRecordEffectSpecID = "gadget/effect/deleteRecord";
export const InvokeCodeEffectSpecID = "gadget/effect/invokeCode";
export const ActionRunEffectSpecID = "gadget/effect/actionRun";
export const ActionOnSuccessEffectSpecID = "gadget/effect/actionOnSuccess";
export type ContributingEffects =
  | typeof InvokeCodeEffectSpecID
  | typeof CreateRecordEffectSpecID
  | typeof UpdateRecordEffectSpecID
  | typeof ActionRunEffectSpecID;
